export default __webpack_public_path__ + "static/media/0x2bc07124d8dac638e290f401046ad584546bc47b.0f24e76b.webp";